import { MODULE_NAME, PERMISSION } from './permission.constant';
// export const menuItems=[
//   {}
// ]

export const menuItems = [
  {
    permission: [PERMISSION.DASHBOARD_LEADS, PERMISSION.DASHBOARD_JOBCARD],
    iconComponent: 'dashIcon',
    title: 'Dashboard',
    keyId: 'dashboard',
    path: '/dashboard',
    isCollapsing: true,
    children: [],
  },

  {
    permission: PERMISSION.LEADS_READ,
    iconComponent: 'leadsIcon',
    icon: '',
    title: 'Leads',
    keyId: 'leads',
    path: '/leads',
  },

  {
    permission: PERMISSION.JOBCARD_READ,
    iconComponent: 'jobcardIcon',
    icon: '',
    title: 'Jobcard',
    keyId: 'jobcard',
    path: '/job-cards',
  },

  {
    permission: PERMISSION.QUOTATION_READ,
    iconComponent: 'quotationIcon',
    icon: '',
    title: 'Quotation',
    keyId: 'quotation',
    path: '/quotations',
  },
  {
    permission: [
      PERMISSION.STOCK_IN_READ,
      PERMISSION.STOCK_OUT_READ,
      PERMISSION.SUPPLIER_RETURN_READ,
      PERMISSION.PART_ITEMS_READ,
      PERMISSION.PART_ISSUE_READ,
      PERMISSION.PART_RETURN_READ,
      PERMISSION.PURCHASE_REQUESTED_READ,
      PERMISSION.CATEGORY_READ,
      PERMISSION.STORAGE_READ,
      PERMISSION.SUBCATEGORY_READ,
    ],
    iconComponent: 'inventory',
    icon: '',
    title: 'Inventory',
    keyId: 'inventory',
    path: '/inventory',
    children: [
      {
        title: 'Parts',
        keyId: 'inventory-parts',
        path: '/inventory/parts',
        permission: [PERMISSION.PART_ITEMS_READ, PERMISSION.PART_ISSUE_READ, PERMISSION.PART_RETURN_READ],
      },
      {
        title: 'Purchase Request',
        keyId: 'inventory-purchase-request',
        path: '/inventory/purchase-request',
        permission: PERMISSION.PURCHASE_REQUESTED_READ,
      },
      {
        title: 'Stock In',
        keyId: 'inventory-stock-in',
        path: '/inventory/stock-in',
        permission: PERMISSION.STOCK_IN_READ,
      },
      {
        title: 'Stock Flow',
        keyId: 'inventory-stock-flow',
        path: '/inventory/stock-flow',
        permission: [PERMISSION.STOCK_OUT_READ, PERMISSION.SUPPLIER_RETURN_READ],
      },
      {
        title: 'Category',
        keyId: 'inventory-category',
        path: '/inventory/category',
        permission: PERMISSION.CATEGORY_READ,
      },
      {
        title: 'Storage',
        keyId: 'inventory-storage',
        path: '/inventory/storage',
        permission: PERMISSION.STORAGE_READ,
      },
      {
        title: 'Supplier',
        keyId: 'inventory-supplier',
        path: '/inventory/supplier',
        permission: PERMISSION.SUPPLIER_READ,
      },
    ],
  },

  {
    permission: [PERMISSION.INVOICE_READ, PERMISSION.PAYMENT_READ],
    iconComponent: 'IconPayment',
    icon: '',
    title: 'Payment',
    keyId: 'payment',
    path: '/payment',
    children: [
      {
        title: 'Invoice',
        keyId: 'payment-invoice',
        path: '/payment/invoices',
        permission: PERMISSION.INVOICE_READ,
      },
      {
        title: 'Payment List',
        keyId: 'payment-list',
        path: '/payment/payment-list',
        permission: PERMISSION.PAYMENT_READ,
      },
    ],
  },

  {
    permission: PERMISSION.GATEPASS_READ,
    iconComponent: 'gatepassIcon',
    icon: '',
    title: 'Gatepass',
    keyId: 'gatepass',
    path: '/gatepass',
  },

  {
    permission: [PERMISSION.USER_READ, PERMISSION.ROLE_READ],
    icon: 'fas fa-user-cog',
    title: 'Users',
    keyId: 'users',
    path: '/users',
    children: [
      {
        title: 'User Management',
        keyId: 'users-management',
        path: '/users/user',
        permission: PERMISSION.USER_READ,
      },
      {
        title: 'Role & Permission',
        keyId: 'users-role',
        path: '/users/role',
        permission: PERMISSION.ROLE_READ,
      },
    ],
  },

  {
    permission: MODULE_NAME.CONFIGURATION,
    icon: 'fas fa-cog',
    title: 'Configurations',
    keyId: 'configurations',
    path: '/configurations',
    children: [
      {
        title: 'Sources',
        keyId: 'config-sources',
        path: '/configurations/sources',
        permission: PERMISSION.SOURCES_READ,
      },
      {
        title: 'Service Type',
        keyId: 'config-service-type',
        path: '/configurations/service-types',
        permission: PERMISSION.SERVICE_TYPE_READ,
      },
      {
        title: 'Brand',
        keyId: 'config-brand',
        path: '/configurations/brands',
        permission: PERMISSION.BRAND_READ,
      },
      {
        title: 'Model',
        keyId: 'config-model',
        path: '/configurations/models',
        permission: PERMISSION.MODEL_READ,
      },
      {
        title: 'Color',
        keyId: 'config-color',
        path: '/configurations/colors',
        permission: PERMISSION.COLOR_READ,
      },
      {
        title: 'Position',
        keyId: 'config-position',
        path: '/configurations/positions',
        permission: PERMISSION.POSITION_READ,
      },
      {
        title: 'Term & Conditions',
        keyId: 'config-terms',
        path: '/configurations/term-condition',
        permission: PERMISSION.TERM_CONDITIONS_READ,
      },
      {
        title: 'Yescar Address',
        keyId: 'config-address',
        path: '/configurations/address-yescar',
        permission: PERMISSION.TERM_CONDITIONS_READ,
      },
    ],
  },
];

export const filterMenu = (optionFilter = []) =>
  structuredClone(menuItems).filter(function f(o) {
    if (optionFilter.find((route) => (Array.isArray(o.permission) ? o.permission : [o.permission]).includes(route))) return true;
    if (o.children) {
      return (o.children = o.children.filter(f)).length;
    }
  });
